import React from "react";
import { observer } from "mobx-react";
import { ShowcaseCategoryUpdateStore } from "../../store";
import { ShowcaseCategoryUpdateForm } from "./ShowcaseCategoryUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type ShowcaseCategoryUpdateProps = {
  showcaseCategoryUpdateStore: ShowcaseCategoryUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ShowcaseCategoryUpdate: React.FC<ShowcaseCategoryUpdateProps> =
  observer(
    ({ showcaseCategoryUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={showcaseCategoryUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={showcaseCategoryUpdateStore.savedButOutdated}
            onReload={() =>
              showcaseCategoryUpdateStore.reloadShowcaseCategory()
            }
            reloadDisabled={showcaseCategoryUpdateStore.isProcessing}
          />
          <ShowcaseCategoryUpdateForm
            showcaseCategoryUpdateStore={showcaseCategoryUpdateStore}
            codeError={showcaseCategoryUpdateStore.errors.code?.message}
            onCodeChange={(value: string) => {
              showcaseCategoryUpdateStore.setCodeValue(value);
            }}
            code={showcaseCategoryUpdateStore.entityValues.code}
            nameError={showcaseCategoryUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              showcaseCategoryUpdateStore.setNameValue(value);
            }}
            name={showcaseCategoryUpdateStore.entityValues.name}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={showcaseCategoryUpdateStore.saveDisabled}
            onSave={() => showcaseCategoryUpdateStore.saveShowcaseCategory()}
            onCancel={() =>
              showcaseCategoryUpdateStore.cancelShowcaseCategory()
            }
          />
          <ErrorDialog
            open={showcaseCategoryUpdateStore.errorDialogOpened}
            title={showcaseCategoryUpdateStore.errorTitle}
            description={showcaseCategoryUpdateStore.errorDescription}
            onClose={() => showcaseCategoryUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={showcaseCategoryUpdateStore.confirmDialogOpened}
            title={showcaseCategoryUpdateStore.confirmDialogTitle}
            description={showcaseCategoryUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              showcaseCategoryUpdateStore.executeConfirmedAction()
            }
            onCancel={() => showcaseCategoryUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
